import { useState } from "react";
import Image from "next/image";
import styles from "./choose.module.css";
import icon1 from "../../assets/images/home/newicon/Upsc.jpg";
import icon2 from "../../assets/images/home/newicon/Tnpsc.jpg";
import icon3 from "../../assets/images/home/newicon/Prefit.jpg";
import Link from "next/link";

const WhyChooseUs = () => {
  
const [activeCard, setActiveCard] = useState(null);

  const miniItems = [
   {
    id: 1,
    title: "UPSC Admissions 2026",
    subtitle: (
      <>
        <div>GS + PCM Batches  </div>
        <div>Complete Preparation  </div>
        <div>With Mentorship </div> <br/>
        <div>Course & Fee Structure  </div>
      </>
    ),
    icon: icon1,
    link: "/upsc-admission-anna-nagar",
  },

  {
    id: 2,
    title: "TNPSC  Admissions 2026",
    subtitle: (
      <>
        <div>GS + PCM Batches  </div>
        <div>Complete Preparation  </div>
        <div>With Mentorship </div> <br/>
         <div>Course & Fee Structure </div>
      </>
    ),
    icon: icon2, // different image
    link: "/tnpsc-admissions/#gspcm",
  },

  
];
  
  return (
     
    <div className="container py-4">
      <style jsx>{`

        .row-wrap {
          display: flex;
          gap: 20px;
          align-items: stretch;
          /* ensure overflow visible so hover expansion isn't clipped */
          overflow: visible;
        }

        @media (hover: none) {
          .mini-right {
            --w: 160px;
            max-width: var(--w);
            opacity: 1;
            transform: none;
          }
        }

        /* ---------- MINI CARD (first two) ---------- */
        .mini-card-wrap {
          flex: 0 0 calc(33.333% - 13.333px); /* three columns layout */
          max-width: calc(33.333% - 13.333px);
        }

        .mini-card {
          background: #ffffff;
          border-radius: 14px;
          padding: 22px 22px;
          box-shadow: 8px 8px 18px rgba(0, 0, 0, 0.25), -8px -8px 18px rgba(255, 255, 255, 1);
          transition: max-width 360ms cubic-bezier(.2,.9,.2,1),
                      box-shadow 360ms ease;
          display: flex;
          align-items: center;
          overflow: visible;
          max-width: 100%;
          height: 100%;
          position: relative;
        }

        /* left text area (default full width inside the mini card) */
        .mini-left {
          flex: 1 1 auto;
          min-width: 0;
        }

        .mini-left .kicker {
          font-weight: 500;
          color: #d71920;
          font-size: 18px;
          //letter-spacing: 0.8px;
          margin-bottom: 8px;
          text-transform: uppercase;
        }

        .mini-left .subtitle {
          font-size: 16px;
          color: #5b6266;
          line-height: 1.3;
          margin: 0 0 12px;
        }

        .mini-left .read {
          font-size: 13px;
          color: #333;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        /* right image hidden by default (reveal on hover) */
       .mini-right {
          --w: 0px;
          max-width: var(--w);
          opacity: 0;
          transform: translateX(12px);
          transition:
            max-width 360ms cubic-bezier(.2,.9,.2,1),
            opacity 260ms ease,
            transform 360ms cubic-bezier(.2,.9,.2,1);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 12px;
          flex-shrink: 0;
        }

        .mini-right.is-active {
          --w: 180px;
          max-width: var(--w);
          opacity: 1;
          transform: translateX(0);
        }


        .mini-right .imgbox {
          width: 120px;
          height: 160px;
          border-radius: 10px;
          overflow: hidden;
          background: #f7fbff;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 20px rgba(12, 20, 30, 0.06);
        }

        

        /* Hover reveal: expand this mini-card and show right column */
        .mini-card-wrap:hover .mini-card {
          box-shadow: 0 18px 40px rgba(8, 30, 60, 0.12);
        }

        .mini-card-wrap:hover .mini-right {
          --w: 180px;   /* reveal up to 180px */
          max-width: var(--w);
          opacity: 1;
          transform: translateX(0);
        }

        

        /* ---------- LARGE RED CARD (third card) ---------- */
        .big-card {
          flex: 0 0 calc(33.333% - 13.333px);
          max-width: calc(33.333% - 13.333px);
          background: #d71920;
          color: #fff;
          border-radius: 16px;
          padding: 24px;
          display: flex;
          gap: 20px;
          align-items: center;
          box-shadow: 0 8px 28px rgba(0,0,0,0.08);
        }

        .big-left {
          flex: 1 1 60%;
        }
        .big-left .title {
          font-size: 20px;
          font-weight: 500;
          margin: 0 0 12px;
        }
        .big-left .desc {
          margin: 0 0 18px;
          line-height: 1.4;
        }
        .big-left .readmore {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-weight: 500;
          padding-top: 10px;
          font-size: 14.5px;
        }

        .big-right {
          //width: 85px;
          height: 200px;
          // background: #fff;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          padding: 10px;
        }

        .roadmapStart {
            font-size: 13.5px;
            /* text-align: justify; */
            line-height: 20px;
           
        }

        /* ---------- RESPONSIVE ---------- */
        @media (max-width: 992px) {
           
          .row-wrap {
            gap: 14px;
          }
          .mini-card-wrap, .big-card {
            flex: 0 0 49%;
            max-width: 49%;
          }
        }

        @media (max-width: 640px) {
          .row-wrap {
            flex-direction: column;
          }
          .mini-card-wrap, .big-card {
            flex: 0 0 100%;
            max-width: 100%;
          }
          .mini-right {
            --w: 100%;
            max-width: 140px;
            opacity: 1;
            transform: none;
            margin-left: 12px;
          }
          .mini-card {
            align-items: center;
          }
          .big-right {
            width: 140px;
            height: 170px;
          }
        }

        @media (max-width: 640px) {

  .row-wrap {
    flex-direction: column;
    gap: 16px;
  }

  .mini-card-wrap,
  .big-card {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .mini-card {
    padding: 18px;
    gap: 12px;
  }

  .mini-left .kicker {
    font-size: 14px;
  }

  .mini-left .subtitle {
    font-size: 15px;
  }

  .mini-right .imgbox {
    width: 100px;
    height: 140px;
  }

  .big-card {
    flex-direction: column;
    text-align: center;
  }

  .big-right {
    width: 130px;
    height: 160px;
  }
}

@media (min-width: 641px) and (max-width: 991px) {



  .row-wrap {
    gap: 16px;
  }

  .mini-card-wrap,
  .big-card {
    flex: 0 0 48%;
    max-width: 48%;
  }

  /* MINI CARDS */
  .mini-card {
    padding: 22px;
  }

  .mini-left .subtitle {
    font-size: 16px;
  }

  .mini-right .imgbox {
    width: 110px;
    height: 150px;
  }

  /* 🔴 BIG CARD FIX (IMPORTANT) */
  .big-card {
  display: none;
    flex-direction: column;      /* STACK CONTENT */
    align-items: center;
    text-align: center;
    padding: 20px;
  }

  .big-left {
    flex: 0 0 auto;
    width: 100%;
  }

  .big-right {
    width: 120px;               /* REDUCED */
    height: 150px;
    margin-top: 14px;
  }
}



      `}</style>

      <div  className="row-wrap">
       {miniItems.map((m) => (
        <div data-aos="flip-up"
          className="mini-card-wrap"
          key={m.id}
          // onMouseEnter={() => setActiveCard(m.id)}
        >
          <div className="mini-card" role="article" aria-label={m.subtitle}>
            <div  className="mini-left">
              <div className="kicker">{m.title}</div>
              <div className="subtitle">{m.subtitle}</div>

              <div className="read pt-2">

                 <Link
                    href={m.link} // ✅ dynamic link
                    className={styles.acheivermore}
                    onClick={() => fbq("track", "ButtonClick")}
                  >
                    <span style={{ fontSize: "14px", color: "#0f0f0f" }}>
                      Read more
                    </span>
                 </Link>

                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path
                    d="M5 12h14M13 5l7 7-7 7"
                    stroke="#d71920"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>

            {/* <div
              className={`mini-right ${
                activeCard === m.id ? "is-active" : ""
              }`}
              aria-hidden="true"
            >
              </div> */}
             <div className="imgbox">
                  <Image
                    src={m.icon}
                    alt="banner"
                    width={140}
                    height={180}
                    style={{ borderRadius: "10px" }}
                  />
                </div>
          </div>
        </div>
        
       ))}


        {/* LARGE RED CARD (always image visible) */}
        <div data-aos="fade-down" className="big-card" role="region" aria-label="Prefit Announcement">
          <div className="big-left">
            <h4 className="title">PRESTORMING</h4>
            <div className="roadmapStart">
              UPSC Prelims Test Series 2026 designed for complete syllabus coverage, exam-oriented practice, and in-depth performance analysis to boost your success.
            </div>
            <div className="readmore">
              <Link
                href="/upsc-prelims-test-series"
                className={`${styles.acheivermore}`}
                id=""  onclick="fbq('track', 'ButtonClick');"
              >
              <span style={{fontSize:"14px", color:"#fff"  }}>  Read more →</span> 
              </Link>
            </div>
          </div>

          <div className="big-right" aria-hidden="true">
            <Image 
            src={icon3} 
            alt="prefit" 
            width={140} 
            height={170} 
            style={{ borderRadius: "10px" }} 
          />
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs;
